import { connect } from 'react-redux';
import DaftarNilaiPraktek from '../../../views/Kurikulum/Ulangan/DaftarNilaiPraktek.view';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}
export default connect(null, mapDispatchToProps)(DaftarNilaiPraktek);
